import { cache } from '@/container/apollo-client/cache';
import { CURSOR_MEMBER_MESSAGES } from '@/graphql/cursor.graphql';
import { ChatMessageSubscription, GetChatMessagesV2Query, useChatMessageSubscription } from '@/types/generated/graphql';

export function useMemberConversationSubscription() {
  useChatMessageSubscription({
    onData: (res) => handleOnData(res?.data?.data as ChatMessageSubscription),
  });

  function handleOnData(data: ChatMessageSubscription) {
    const cachedMessages = cache.readQuery<GetChatMessagesV2Query>({
      query: CURSOR_MEMBER_MESSAGES,
      variables: {
        roomId: data.chatMessage?.room?.id,
      },
    });
    // need to check this condition because in case of primary sender among groups, it would be already appended
    const alreadyAppendedToCache = cachedMessages?.getChatMessagesV2?.data?.find(
      (message) => message?.id === data?.chatMessage?.id
    );

    if (alreadyAppendedToCache) {
      return;
    }

    cache.updateQuery(
      {
        query: CURSOR_MEMBER_MESSAGES,
        variables: {
          roomId: data.chatMessage?.room?.id,
        },
      },
      (cachedData) => {
        const newMessage = {
          ...data?.chatMessage,
          isPinned: false,
          messageConversation: {
            conversationStatus: null,
            effectiveEndedAt: null,
            effectiveStartedAt: null,
            id: null,
          },
        };

        return {
          ...cachedData,
          getChatMessagesV2: {
            ...cachedData?.getChatMessagesV2,
            data: [newMessage, ...(cachedData?.getChatMessagesV2?.data || [])],
          },
        };
      }
    );
  }
}
